import {css} from 'styled-components'

export const ResetStyles = css`  
  @layer base {
    * {
      margin: 0;
      padding: 0;
      border: 0;
      box-sizing: border-box;
    }
    
    body {
      margin: 0;
      padding: 0;
      border: 0;
    }

    :focus,
    :focus-visible {
      outline: 0;
    }

    button,
    input {
      background: inherit;
      font-family: inherit;
      
      
    }

    article,
    aside,
    details,
    figcaption,
    figure,
    footer,
    header,
    hgroup,
    menu,
    nav,
    section {
      display: block;
    }

    body {
      line-height: auto;
    }

    ol,
    ul {
      list-style: none;
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    textarea {
      overflow: auto;
      vertical-align: top;
      resize: vertical;
    }

    audio,
    canvas,
    video {
      display: inline-block;
      max-width: 100%;
    }

    audio:not([controls]) {
      display: none;
      height: 0;
    }

    [hidden] {
      display: none;
    }

    a:focus {
      outline: none;
    }

    a:active,
    a:hover {
      outline: 0;
    }

    img {
      border: 0;
      -ms-interpolation-mode: bicubic;
    }

    figure {
      margin: 0;
    }

    form {
      margin: 0;
    }

    button,
    input,
    select,
    textarea {
      margin: 0;
      vertical-align: baseline;
    }

    button {
      border: unset;
    }

    button,
    input {
      line-height: normal;
    }

    button,
    select {
      text-transform: none;
    }

    button,
    html input[type='button'],
    input[type='reset'],
    input[type='submit'] {
      -webkit-appearance: button;
      cursor: pointer;
    }

    button[disabled],
    html input[disabled] {
      cursor: default;
    }

    input[type='checkbox'],
    input[type='radio'] {
      box-sizing: border-box;
      padding: 0;
    }

    button::-moz-focus-inner,
    input::-moz-focus-inner {
      border: 0;
      padding: 0;
    }

    textarea {
      overflow: auto;
      vertical-align: top;
    }

    table {
      border-collapse: collapse;
      border-spacing: 0;
    }

    img {
      vertical-align: middle;
    }

    a,
    a:-webkit-any-link {
      text-decoration: none;
    }

    iframe {
      border: 0;
    }

    .sb-show-main.sb-main-centered,
    .sb-show-main.sb-main-padded {
      display: block;
      padding: unset;
    }

    .sb-show-main.sb-main-centered #storybook-root,
    .sb-show-main.sb-main-padded #storybook-root {
      padding: unset;
    }
  }
`
